/**
 * Namely this detects usage of older IE browsers
 */
export default function isBadBrowser () {
  const { navigator } = global
  if (!navigator) return false
  const { userAgent } = navigator

  if (/MSIE/.test(userAgent) && !/MSIE (10|11)/.test(userAgent)) return true
  return false
}



// WEBPACK FOOTER //
// ./modules/utils/isBadBrowser.js